import { render, staticRenderFns } from "./CrossIcon.vue?vue&type=template&id=811a19cc&"
import script from "./CrossIcon.vue?vue&type=script&lang=js&"
export * from "./CrossIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports